import { render, staticRenderFns } from "./OthOut.vue?vue&type=template&id=8f1a7602"
import script from "./OthOut.vue?vue&type=script&lang=js"
export * from "./OthOut.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports